import { render, staticRenderFns } from "./picup.vue?vue&type=template&id=3633e6db&scoped=true&"
import script from "./picup.vue?vue&type=script&lang=js&"
export * from "./picup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3633e6db",
  null
  
)

export default component.exports